import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, Linkedin } from 'lucide-react';
import { siteConfig } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0A0A] border-t border-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <span className="font-display text-2xl font-semibold text-white">
                Joy<span className="text-[#C9A962]">Ogbekene</span>
              </span>
            </Link>
            <p className="text-[#707070] text-sm leading-relaxed max-w-md mb-6">
              Professional Nigerian & African female voice artist with over 20 years 
              of experience delivering compelling voiceovers across continents, 
              cultures, and platforms.
            </p>
            <div className="flex flex-col gap-3">
              <a 
                href="mailto:hello@joyogbekene.com"
                className="inline-flex items-center gap-2 text-[#B8B8B8] hover:text-[#C9A962] transition-colors text-sm"
              >
                <Mail size={16} />
                hello@joyogbekene.com
              </a>
            </div>
            {/* Social Media Links */}
            <div className="flex items-center gap-4 mt-6">
              <a 
                href="https://www.instagram.com/JoyogbekeneVO"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#1A1A1A] border border-[#2A2A2A] rounded-full flex items-center justify-center text-[#707070] hover:text-[#C9A962] hover:border-[#C9A962] transition-all"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a 
                href="https://www.linkedin.com/in/joy-ogbekene-b2778114/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#1A1A1A] border border-[#2A2A2A] rounded-full flex items-center justify-center text-[#707070] hover:text-[#C9A962] hover:border-[#C9A962] transition-all"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-medium mb-6">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'About', path: '/about' },
                { name: 'Demos', path: '/demos' },
                { name: 'Gallery', path: '/gallery' },
                { name: 'Contact', path: '/contact' },
                { name: 'Legal', path: '/legal' },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-[#707070] hover:text-[#C9A962] transition-colors text-sm"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-medium mb-6">Services</h4>
            <nav className="flex flex-col gap-3">
              {[
                'Commercial Voiceover',
                'Corporate Narration',
                'IVR & Telephone',
                'Documentary',
                'Nigerian Pidgin',
              ].map((service) => (
                <span
                  key={service}
                  className="text-[#707070] text-sm"
                >
                  {service}
                </span>
              ))}
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#1A1A1A] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#505050] text-sm">
            © {currentYear} Joy Ogbekene. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/legal" className="text-[#505050] hover:text-[#C9A962] text-sm transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/legal" className="text-[#505050] hover:text-[#C9A962] text-sm transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
